import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import { handleError } from './user';

export const setCalendarData = createAction('SET_CALENDAR_DATA');
export const setShiftDetail = createAction('SET_SHIFT_DETAIL');
export const setMonth = createAction('SET_MONTH');
export const setYear = createAction('SET_YEAR');
export const clearPreviousData = createAction('CLEAR_PREVIOUS_DATA');
export const setReasonValue = createAction('SET_REASON_VALUE');

const initialState = {
	calendarArray: [],
	month: '',
	reasonValue: '',
	shiftDetails: {},
	year: ''
};

export default handleActions(
	{
		CLEAR_PREVIOUS_DATA: (state) => ({
			...state,
			calendarArray: initialState.calendarArray
		}),
		SET_CALENDAR_DATA: (state, action) => ({
			...state,
			calendarArray: action.payload
		}),
		SET_MONTH: (state, action) => ({ ...state, month: action.payload }),
		SET_REASON_VALUE: (state, action) => ({
			...state,
			reasonValue: action.payload
		}),
		SET_SHIFT_DETAIL: (state, action) => ({
			...state,
			shiftDetails: action.payload
		}),
		SET_YEAR: (state, action) => ({ ...state, year: action.payload })
	},
	initialState
);

export const getShift = (id) => {
	return function (dispatch) {
		Agent.getShiftDetail(id).then((response) => {
			if (response.ok) {
				dispatch(setShiftDetail(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
